export namespace TaskGroupEditorHubItemKeys {
    export const RefreshMenuItem = "task-group-editor-refresh";
    export const DiscardMenuItem = "task-group-editor-discard";
    export const ExportMenuItem = "task-group-editor-export";
    export const SecurityMenuItem = "task-group-editor-security";
    export const SaveMenuItem = "task-group-editor-save-parent";
    export const SaveSubMenuItem = "task-group-editor-save";
    export const SaveAsDraftSubMenuItem = "task-group-editor-save-draft";
    export const PublishDraftMenuItem = "task-group-editor-publish-draft";
    export const PublishPreviewMenuItem = "task-group-editor-publish-preview";
    export const TaskGroupsBreadcrumbItemKey = "task-group-editor-task-groups-breadcrumb-key";
    export const TaskGroupVersionActionItemKey = "task-group-editor-version-action-item-key";
}

export namespace TaskGroupEditorInstanceIds {
    export const TaskGroupEditorStoresInstanceIdFormat = "task-group-editor-instance-id-{0}";
}

export namespace TaskGroupRevisionsListColumnKeys {
    export const Version = "task-group-revisions-version-column-key";
}

export namespace TaskGroupReferenceListColumnKeys {
    export const Name = "task-group-references-name-column-key";
    export const ChildReferences = "task-group-references-child-references-column-key";
}

export namespace TasksTabKeys {
    export const TasksTabSharedViewKey = "task-group-editor-tasks-tab-shared-view-key";
}

export namespace ActionCreatorKeys {
    export const TaskGroupHistoryActionCreator = "ACTION_CREATOR_KEY_TASK_GROUP_HISTORY_ACTION_CREATOR";
    export const TaskGroupEditorActionCreator = "ACTION_CREATOR_KEY_TASK_GROUP_EDITOR_ACTION_CREATOR";
    export const TaskGroupTabActionCreator = "STORE_KEY_TASK_GROUP_TAB_ACTION_CREATOR";
    export const TaskGroupTasksTabActionCreator = "STORE_KEY_TASK_GROUP_TASKS_TAB_ACTION_CREATOR";
    export const TaskGroupPropertiesItemActionCreator = "STORE_KEY_TASK_GROUP_PROPERTIES_ITEM_ACTION_CREATOR";
    export const TaskGroupVersionsActionCreator = "STORE_KEY_TASK_GROUP_VERSIONS_ACTION_CREATOR";
}

export namespace ActionKeys {
    export const TaskGroupEditorTabsActionHub = "ACTION_HUB_KEY_TASK_GROUP_EDITOR_TABS_ACTION_HUB";
    export const TaskGroupTasksTabActionsHub = "STORE_KEY_TASK_GROUP_TASKS_TAB_ACTION_HUB";
    export const TaskGroupPropertiesItemActionsHub = "STORE_KEY_TASK_GROUP_PROPERTIES_ITEM_ACTION_HUB";
    export const TaskGroupVersionsActionsHub = "STORE_KEY_TASK_GROUP_VERSIONS_ACTION_HUB";
}

export namespace StoreKeys {
    export const TaskGroupEditorStore = "STORE_KEY_TASK_GROUP_EDITOR_STORE";
    export const TaskGroupReferencesViewStore = "STORE_KEY_TASK_GROUP_REFERENCES_VIEW_STORE";
    export const TaskGroupTabStore = "STORE_KEY_TASK_GROUP_TAB_STORE";
    export const TaskGroupTasksTabStore = "STORE_KEY_TASK_GROUP_TASKS_TAB_STORE";
    export const TaskGroupPropertiesItemStore = "STORE_KEY_TASK_GROUP_PROPERTIES_ITEM_STORE";
    export const TaskGroupVersionsStore = "STORE_KEY_TASK_GROUP_VERSIONS_STORE";
    export const TaskGroupHistoryStore = "STORE_KEY_TASK_GROUP_HISTORY_STORE";
}

export namespace MessageAreaKeys {
    export const TaskGroupEditorHistoryMessageAreaKey = "task-group-editor-history-error-bar-key";
    export const TaskGroupEditorTasksMessageAreaKey = "task-group-editor-tasks-error-bar-key";
    export const TaskGroupEditorReferencesMessageAreaKey = "task-group-editor-references-error-bar-key";
}

export namespace TabInstanceIds {
    export const Tasks = "tasks-tab";
    export const History = "history-tab";
    export const References = "references-tab";
}

export namespace Dimesnions {
    export const TaskGroupReferencesLeftPaneWidth = "350px";
}